var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95069 2.41679C5.01259 1.84982 2.98691 2.94183 2.4173 4.83403C1.84891 6.72217 2.93796 8.71892 4.87233 9.2848C5.78866 9.55286 6.64315 9.63381 7.29766 9.38017C7.54228 9.28538 7.81975 9.34286 8.00657 9.52703L12.2737 13.7336H13.733V12.314L9.46981 8.11138C9.31243 7.95623 9.24216 7.73318 9.2822 7.51584L9.38846 6.93896C9.3929 6.91486 9.39866 6.89102 9.40572 6.86755C9.97411 4.97942 8.88507 2.98266 6.95069 2.41679ZM1.14056 4.44969C1.92555 1.84203 4.69843 0.368705 7.32505 1.13709C9.94314 1.90297 11.4545 4.61473 10.6933 7.21536L10.6575 7.40989L14.8677 11.5603C14.9948 11.6856 15.0663 11.8566 15.0663 12.035V14.4002C15.0663 14.7684 14.7679 15.0669 14.3997 15.0669H12.0004C11.8252 15.0669 11.6571 14.998 11.5324 14.875L7.35443 10.7564C6.39587 10.9898 5.3681 10.819 4.49797 10.5645C1.86762 9.79502 0.35435 7.06141 1.14056 4.44969ZM5.33317 6.00004C5.33317 5.63185 5.63164 5.33338 5.99983 5.33338H6.08061C6.4488 5.33338 6.74728 5.63185 6.74728 6.00004C6.74728 6.36823 6.4488 6.66671 6.08061 6.66671H5.99983C5.63164 6.66671 5.33317 6.36823 5.33317 6.00004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKey);
export default __webpack_public_path__ + "static/media/ic-key.a237101e111195eb5e5378d3bee2178b.svg";
export { ForwardRef as ReactComponent };